// src/lib/sound.ts
let ctx: AudioContext | null = null;
let buffer: AudioBuffer | null = null;
let unlocked = false;

export async function unlockAudio() {
  if (!ctx) {
    const AC: typeof AudioContext = (window as any).AudioContext || (window as any).webkitAudioContext;
    ctx = new AC();
  }
  if (ctx.state === "suspended") await ctx.resume();

  if (!buffer) {
    // synth a short beep (no assets, no CORS)
    const sr = ctx.sampleRate;
    const dur = 0.25;
    const b = ctx.createBuffer(1, Math.floor(sr * dur), sr);
    const ch = b.getChannelData(0);
    const freq = 880;
    for (let i = 0; i < ch.length; i++) {
      const t = i / sr;
      const attack = Math.min(1, t / 0.01);
      const release = Math.max(0, 1 - Math.max(0, t - 0.18) / 0.07);
      ch[i] = Math.sin(2 * Math.PI * freq * t) * attack * release;
    }
    buffer = b;
  }
  unlocked = true;
}

export async function ensureAudioContext() {
  if (!ctx) {
    await unlockAudio();
    return ctx;
  }
  if (ctx.state === "suspended") await ctx.resume();
  return ctx;
}

/** returns true if Web Audio played (so caller can skip HTML <audio> fallback) */
export function playAlarm(repeats = 3, gapMs = 180, volume = 0.75): boolean {
  if (!ctx || !buffer || !unlocked) return false;
  const startAt = ctx.currentTime + 0.01;
  for (let i = 0; i < repeats; i++) {
    const src = ctx.createBufferSource();
    const gain = ctx.createGain();
    gain.gain.value = volume;
    src.buffer = buffer;
    src.connect(gain).connect(ctx.destination);
    src.start(startAt + i * (buffer.duration + gapMs / 1000));
  }
  return true;
}
